import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { RiEditFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRpmUserNotesToPatientList,
  setSelectedRpmPatient,
} from "../../../../../Redux/actions/rpmActions";
import AddClinicalNote from "./addClinicalNote";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { APP_ROUTES } from "../../../../../PageRouting/approutes";

function Index() {
  const [addNewNoteMod, setAddNewMod] = useState(false);
  const [isNotesUpdated, setIsNotesUpdated] = useState(false);
  const { selectedRpmPatient, userNotesToPatient } = useSelector(
    (state) => state.rpm
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const handleAddNoteModal = () => {
    setAddNewMod(!addNewNoteMod);
  };

  useEffect(() => {
    const payload = {
      patientCode: selectedRpmPatient.patientId,
      status: 1,
    };
    dispatch(fetchRpmUserNotesToPatientList(payload));
  }, []);

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  useEffect(() => {
    if (isNotesUpdated) {
      const payload = {
        patientCode: selectedRpmPatient.patientId,
        status: 1,
      };
      dispatch(fetchRpmUserNotesToPatientList(payload));
      setIsNotesUpdated(false);
    }
  }, [isNotesUpdated]);

  const handleNavigation = () => {
    history.push(APP_ROUTES.RPMCLINICALNOTES);
  };

  return (
    <div>
      <div className="bg-white rounded-lg p-3 h-fit flex flex-col justify-between border">
        <div className="flex justify-between items-center pb-2">
          <div className="text-black text-base font-sans font-bold">
            Clinical Notes
          </div>
          <button onClick={handleAddNoteModal} className="bg-white">
            <RiEditFill className="w-5 h-5  cursor-pointer text-cyan-700" />
          </button>
        </div>

        <div className="text-sm text-gray-500 border  rounded-lg p-2 mt-3 h-32 overflow-y-scroll scrollHide">
          <div className="flex flex-col gap-1.5">
            {userNotesToPatient.map((item) => (
              <div className="bg-green-200 text-brand-White rounded-md p-2">
                <p>{item.notes}</p>
                <div className="w-full flex justify-between mt-3 text-xs font-extralight">
                  <span>{item.createdName}</span>
                  <span>{item.createdDate}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div onClick={handleNavigation} className="text-center mt-3 text-brand-primaryColor hover:underline cursor-pointer text-sm font-inter font-medium">
          See All
        </div>
      </div>

      {/* Add new clinical note */}

      <Modal
        open={addNewNoteMod}
        onCancel={handleAddNoteModal}
        footer={[]}
        destroyOnClose
      >
        <AddClinicalNote
          isBackButtonPresent={false}
          setIsNotesUpdated={setIsNotesUpdated}
        />
      </Modal>
    </div>
  );
}

export default Index;
